export function isClientRoute(href?: string) {
  return href?.startsWith('/', 0) && !href?.startsWith('mailto');
}
